// import React from 'react';
// import { Box } from '@mui/material';
// import { format, addHours } from 'date-fns';
// import './DateTimeInputs.css'
// import Tooltip from '@mui/material/Tooltip';

// const requiredAsteriskStyle = {
//     color: 'red',
//     marginLeft: '4px',
//     fontSize: '1.2em',
//     verticalAlign: 'top',
// };


// const DateTimeInputs = ({ scheduleDate, setScheduleDate, expiryDate, setExpiryDate, minScheduleDate, minExpiryDate, isEdit, workStart, setWorkStart, workEnd, setWorkEnd, }) => {
//     const minNow = format(new Date(), "yyyy-MM-dd'T'HH:mm");
//     return (
//         <>
//             <Box sx={{ mb: 0, display: "flex", flexDirection: "column", gap: 1.5 }}>
//                 <div className="row">
//                     <div className="col-md-3">
//                         <Box>
//                             <label className="date-label">
//                                 Schedule Date & Time<span className="required-asterisk">*</span>
//                             </label>
//                             <input
//                                 type="datetime-local"
//                                 value={scheduleDate}
//                                 disabled={isEdit}
//                                 onChange={(e) => {
//                                     setScheduleDate(e.target.value);
//                                     const newSchedule = new Date(e.target.value);
//                                     const currentExpiry = new Date(expiryDate);
//                                     if (currentExpiry < newSchedule) {
//                                         setExpiryDate(format(addHours(newSchedule, 9), "yyyy-MM-dd'T'HH:mm"));
//                                     }
//                                 }}
//                                 min={minScheduleDate || minNow}
//                                 className="form-control"
//                                 required
//                             />
//                         </Box>
//                     </div>

//                     <div className="col-md-3">
//                         <Box>
//                             <label className="date-label">
//                                 Expiry Date & Time<span className="required-asterisk">*</span>
//                             </label>
//                             <input
//                                 type="datetime-local"
//                                 value={expiryDate}
//                                 disabled={isEdit}
//                                 onChange={(e) => setExpiryDate(e.target.value)}
//                                 min={minExpiryDate}
//                                 className="form-control"
//                                 required
//                             />
//                         </Box>
//                     </div>

//                     <div className="col-md-6">

//                         <Box>
//                             <label className="date-label" style={{ display: "flex", alignItems: "center" }}>
//                                 Work Time Period<span className="required-asterisk">*</span>



//                                 <Tooltip
//                                     title={
//                                         <span style={{ fontSize: '15px' }}>
//                                             {/* Exams will be assigned to employees only in these time periods. */}
//                                             The system will assign assessments to employees only during the time periods you choose. Assessments will not be scheduled outside these times.
//                                         </span>
//                                     }
//                                     arrow
//                                     placement="right"

//                                 >
//                                     <span
//                                         style={{
//                                             marginLeft: "6px",
//                                             cursor: "pointer",
//                                             color: "#0191c8",
//                                             fontSize: "16px",
//                                             fontWeight: "bold",
//                                             display: "inline-block"
//                                         }}
//                                     >
//                                         ⓘ
//                                     </span>
//                                 </Tooltip>

//                             </label>

//                             <div style={{ display: "flex", gap: "10px" }}>
//                                 <input
//                                     type="time"
//                                     value={workStart}
//                                     disabled={isEdit}
//                                     onChange={(e) => setWorkStart(e.target.value + ":00")}
//                                     className="form-control"
//                                     required
//                                 />

//                                 <span style={{ fontWeight: "bold", alignSelf: "center" }}>to</span>

//                                 <input
//                                     type="time"
//                                     value={workEnd}
//                                     disabled={isEdit}
//                                     onChange={(e) => setWorkEnd(e.target.value + ":00")}
//                                     className="form-control"
//                                     required
//                                 />
//                             </div>
//                         </Box>
//                     </div>
//                 </div>
//             </Box>


//         </>
//     );
// };

// export default DateTimeInputs;


import React from 'react';
import { Box } from '@mui/material';
import { format, addHours } from 'date-fns';
import './DateTimeInputs.css';
import Tooltip from '@mui/material/Tooltip';

const DateTimeInputs = ({
  scheduleDate,
  setScheduleDate,
  expiryDate,
  setExpiryDate,
  minScheduleDate,
  minExpiryDate,
  isEdit,
  workStart,
  setWorkStart,
  workEnd,
  setWorkEnd,
}) => {
  const minNow = format(new Date(), "yyyy-MM-dd'T'HH:mm");

  return (
    <>
      <Box sx={{ mb: 0, display: "flex", flexDirection: "column", gap: 1.5 }}>
        <div className="row align-items-end">

          {/* Schedule Date */}
          <div className="col-md-6">
            <Box>
              <label className="date-label">
                Schedule Date & Time
                <span className="required-asterisk">*</span>
              </label>
              <input
                type="datetime-local"
                value={scheduleDate}
                disabled={isEdit}
                onChange={(e) => {
                  setScheduleDate(e.target.value);
                  const newSchedule = new Date(e.target.value);
                  const currentExpiry = new Date(expiryDate);

                  if (currentExpiry < newSchedule) {
                    setExpiryDate(
                      format(addHours(newSchedule, 9), "yyyy-MM-dd'T'HH:mm")
                    );
                  }
                }}
                min={minScheduleDate || minNow}
                className="form-control"
                required
              />
            </Box>
          </div>

          {/* Expiry Date */}
          <div className="col-md-6">
            <Box>
              <label className="date-label">
                Expiry Date & Time
                <span className="required-asterisk">*</span>
              </label>
              <input
                type="datetime-local"
                value={expiryDate}
                disabled={isEdit}
                onChange={(e) => setExpiryDate(e.target.value)}
                min={minExpiryDate}
                className="form-control"
                required
              />
            </Box>
          </div>

          {/* Work Time Period is intentionally hidden in the frontend only.
              Its state and payload integration remain unchanged. */}
          {false && <>
          {/* Divider */}
          <div className="col-md-auto d-flex justify-content-center">
            <div
              style={{
                height: "35px",
                borderLeft: "2px solid #d1d5db",
                margin: "0 15px",
              }}
            />
          </div>

          {/* Work Time Period */}
          <div className="col-md-5">
            <Box>
              <label
                className="date-label"
                style={{ display: "flex", alignItems: "center" }}
              >
                Work Time Period
                <span className="required-asterisk">*</span>

                <Tooltip
                  title={
                    <span style={{ fontSize: '15px' }}>
                      The system will assign assessments to employees only
                      during the time periods you choose. Assessments will not
                      be scheduled outside these times.
                    </span>
                  }
                  arrow
                  placement="right"
                >
                  <span
                    style={{
                      marginLeft: "6px",
                      cursor: "pointer",
                      color: "#0191c8",
                      fontSize: "16px",
                      fontWeight: "bold",
                      display: "inline-block"
                    }}
                  >
                    ⓘ
                  </span>
                </Tooltip>
              </label>

              <div style={{ display: "flex", gap: "10px" }}>
                <input
                  type="time"
                  value={workStart}
                  disabled={isEdit}
                  onChange={(e) =>{
                    if (!e.target.value) return;
                    setWorkStart(e.target.value + ":00")
                  }}
                  className="form-control"
                  required
                />

                <span
                  style={{
                    fontWeight: "bold",
                    alignSelf: "center"
                  }}
                >
                  to
                </span>

                <input
                  type="time"
                  value={workEnd}
                  disabled={isEdit}
                  onChange={(e) =>{
                    if (!e.target.value) return;
                    setWorkEnd(e.target.value + ":00")
                  }
                  }
                  className="form-control"
                  required
                />
              </div>
            </Box>
          </div>
          </>}

        </div>
      </Box>
    </>
  );
};

export default DateTimeInputs;
